import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { ZohoRecruitEmbedStyles as S } from './ZohoRecruitEmbed.styles';
import brand from '@helpers/brand';
const ZohoRecruitEmbed = ({ title, summary, removeCity = false, removeDateOpened = false, removeJobType = false, removeJobDescription = false, additionalFields = [], ...props }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src =
            'https://static.zohocdn.com/recruit/embed_careers_site/javascript/v1.1/embed_jobs.js';
        script.type = 'text/javascript';
        script.onload = () => {
            if (window.rec_embed_js) {
                window.rec_embed_js.load({
                    widget_id: 'rec_job_listing_div',
                    page_name: 'Careers',
                    source: 'CareerSite',
                    site: 'https://learningpeople.zohorecruit.com',
                    brand_color: brand.green.base,
                    empty_job_msg: 'No current Openings',
                    extra_fields: additionalFields,
                });
            }
        };
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("link", { rel: "stylesheet", href: "https://static.zohocdn.com/recruit/embed_careers_site/css/v1.1/embed_jobs.css", type: "text/css" })),
        React.createElement(S.Container, { id: props.anchorId },
            React.createElement(S.Inner, null,
                (title || summary) && (React.createElement(S.TopArea, null,
                    title && React.createElement(S.Title, null, title),
                    summary && React.createElement(S.Summary, null, summary))),
                React.createElement(S.Wrapper, { "data-remove-city": removeCity, "data-remove-date-opened": removeDateOpened, "data-remove-job-type": removeJobType, "data-remove-job-description": removeJobDescription },
                    React.createElement("div", { className: "embed_jobs_head embed_jobs_with_style_3" },
                        React.createElement("div", { className: "embed_jobs_head2" },
                            React.createElement("div", { className: "embed_jobs_head3" },
                                React.createElement("div", { id: "rec_job_listing_div" })))))))));
};
export default ZohoRecruitEmbed;
